import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import _ from "lodash"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
// import { withPrefix } from "gatsby";
import { hyphenDelimitedLowerCase, titleCase } from "../utils/functions"
import { BASE_URL } from "../utils/constants"

export default function LocationCarousel(props) {
  const lazyLoadImage = props.lazyLoadImage
  const enableProgressiveImageLoading = props.enableProgressiveImageLoading
  const carouselLabel = props.data
    .map(function (elem) {
      return elem
    })
    .join("|")
  const positionLabel = props.data
    .map(function (elem, index) {
      return index + 1
    })
    .join("|")
  const tilePosition = props.numberOfCarousels ? props.numberOfCarousels + 1 : 1
  const homepageURL = (props.homepageUrl === "/id/" || props.homepageUrl === "/th/" || props.homepageUrl === "/sg/")?"/":props.homepageUrl
  const cardData = props.data.map((location, index) => {
    // console.log("withPrefix",withPrefix)
    const loc = titleCase(location)
    const url = hyphenDelimitedLowerCase(location)
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "",
      currencyCode: "",
      discount: "",
      hidden: "",
      image:
        // "https://static.stgairasia.com/seo/static-assets/SEOFood/carousel/Food_Delivery_Generic_carousel.jpg",
        // "https://images.contentstack.io/v3/assets/blt51aa173d8d62b412/bltb90df90420b683c8/612eeae1f30d085bb45b8d54/free-meal-extended-kv.jpg?height=180&quality=90&format=jpg&auto=webp",
        // location.imageURL||
        homepageURL==="/th/th/"||homepageURL==="/id/id/"?"https://static.stgairasia.com/seo/static-assets/SEOFood/carousel"+homepageURL.substring(0, 3) + '-' + homepageURL.substring(3+1)+
        hyphenDelimitedLowerCase(location) +
        ".jpg":"https://static.stgairasia.com/seo/static-assets/SEOFood/carousel/" +
        hyphenDelimitedLowerCase(location) +
        ".jpg",
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: "",
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: "",
      timer: "",
      title: loc,
      url: BASE_URL + "/" + url + homepageURL
    }
  })

  const gtmUserType = getGtmUserType()

  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: `${GTM_PROJECT_CATEGORY}|carousel|CityInternalLink|${tilePosition}`,
          eventLabelCardClick: `${GTM_PROJECT_CATEGORY}|{{cardtitle}}|{{cardposition}}`,
          eventLabelHeadlineClick: `${gtmUserType}|headline|{{headline}}`,
          eventLabelView: `${carouselLabel}|${positionLabel}`,
          // eventLabelView: `${GTM_PROJECT_CATEGORY}|${gtmUserType}`
        },
        headline: "",
        headlineStyle: "h2",
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Food Location Widget",
        widgetWidth: "3",
      }}
      gtmConsumerName={props.gtmConsumerName}
      fireGtm={obj => {
        fireGtmEvent(obj)
        // if(!tilePosition)fireGtmEvent(obj)
      }}
      isLoading={false}
      isHideFooter={true}
      handleClick={function noRefCheck() {}}
      templateType="productCard"
      theme="AIRASIA_CLASSIC"
      lazyLoadImage={lazyLoadImage}
      enableProgressiveImageLoading={enableProgressiveImageLoading}
    />
  )
}
